module.exports = __webpack_public_path__ + "static/media/joy_cheng.fbb57aac.png";